import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { EditProductPage } from './edit-product.page';
import { SharedModule } from '../../shared-module/shared.module';
import { EditProductPageRoutingModule } from './edit-product-routing.module';

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    EditProductPageRoutingModule
  ],
  declarations: [EditProductPage]
})
export class EditProductPageModule { }
